import { FormControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function EmailAddressValidator(control: FormControl): ValidationErrors | null {
    let regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    if (control.value) {
        let inputValue = null;
        if (control.value instanceof String) {
            inputValue = control.value.trim();
        } else {
            inputValue = control.value;
        }
        if (!regex.test(inputValue)) {
            return { "invalidEmail": true };
        }
    }
    return null;
}